export const DISTANCE_UNIT = 'км';
